"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.noCredits.message': 'No tienes suficientes créditos para usar el servicio de chat. Por favor, compra más créditos para continuar.',
};
